import React, { useEffect, useRef, useState } from "react";
import { Row, Form, Col, Button, Container } from "react-bootstrap";
import pdfIcon from "../../../Assets/Images/CRM/pdf.svg";
import { commonService } from "../../../utils/commonService";
import DatePicker from "react-datepicker";
import { API_URL } from "../../../utils/apiRoutes";
import { validationRule } from "../../../utils/constant";
import { hotelListCommon } from "../Hotels/HotelListCommon";
import { AccountListCommon } from "../Contacts/AccountListCommon";
import { checkValidation } from "../../../utils/helper";
import { apiCall } from "../../../utils/axiosService";
import { apiResponse } from "../../../utils/apiResponse";
import { successToastMessage } from "../../../utils/toastMessage";
import Select from "react-select";
import filterIcon from "../../../Assets/Images/CRM/filter.png";
import { useSelector } from "react-redux";
import Loader from "../../Loader/Loader";
import { Link } from "react-router-dom";

const RFPGridReport = ({ title }) => {
  const [moduleWisePropertyDropDown, setModuleWisePropertyDropDown] = useState(
    []
  );
  const [selectedModuleWiseProperty, setSelectedModuleWiseProperty] = useState(
    []
  );
  const [selectStatusTerm, setStatusTerm] = useState([]);
  const [termList, setTermList] = useState([]);
  const [selectProperty, setSelectProperty] = useState([]);
  const [propertyValue, setPropertyValue] = useState([]);
  const [errorMessage, setErrorMessage] = useState(false);
  const userIdList = useRef("");
  const statusList = useRef("");
  const propertyIdList = useRef("");
  const [loading, setLoading] = useState(false);
  const [hotelList, setHotelList] = useState(null);
  const [accountList, setAccountList] = useState(null);
  const setPdfRef = useRef("");
  const [showPdf, setShowPdf] = useState(false);
  const [showAllReport, setshowAllReport] = useState(false);
  const isDefaultApiCalledRef = useRef(false);
  const handleshowAllReport = () => {
    setshowAllReport(!showAllReport);
  };
  const userDetails = commonService.getLoginUserData();

  const crmPropertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.crmPropertyDetail
  );

  let propertyIdPayload = "";
  if (crmPropertyDetailFromRTK) {
    if (crmPropertyDetailFromRTK?.propertyid === "") {
      let propertyPayload = crmPropertyDetailFromRTK?.allPropertyId;
      propertyIdPayload = propertyPayload.slice(0, -1);
    } else {
      propertyIdPayload = crmPropertyDetailFromRTK?.propertyid?.toString();
    }
  }

  let startDate = new Date();
  let endDate = new Date(startDate.getTime() - 7 * 24 * 60 * 60 * 1000);

  let validationObj = {
    propertyID: "",
    userId: "",
    statuses: "",
    startDate: endDate,
    endDate: startDate,

    validationRule: [
      {
        fieldName: "propertyID",
        rule: validationRule.required,
        message: "Property Id required",
      },
      {
        fieldName: "userId",
        rule: validationRule.required,
        message: "User selection required",
      },
      {
        fieldName: "startDate",
        rule: validationRule.required,
        message: "Start Date is required",
      },
      {
        fieldName: "endDate",
        rule: validationRule.required,
        message: "End Date is required",
      },
      {
        fieldName: "statuses",
        rule: validationRule.required,
        message: "Status is required",
      },
    ],
    errorObj: {},
    isValidate: true,
  };
  const [RFPData, setRFPData] = useState(validationObj);
  const RFPDataRef = useRef(RFPData);

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    RFPDataRef.current.startDate = start;
    RFPDataRef.current.endDate = end;
    setRFPData({
      ...RFPData,
      startDate: start,
      endDate: end,
    });
  };

  const getHotelList = async () => {
    let response = await hotelListCommon(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.CRM +
          API_URL.PROPERTY_TERM.GET_PROPERTY_LIST_BY_USER_ID,
        body: {
          id: userDetails?.userid,
        },
      },
      false
    );

    if (response?.isValidate) {
      setHotelList(response?.data);
      let propertyListarry = [];
      response?.data?.map((item) => {
        propertyListarry = [
          ...propertyListarry,
          {
            label: item?.propertyname,
            value: item?.propertyid,
          },
        ];
      });
      setSelectProperty(propertyListarry);

      if (crmPropertyDetailFromRTK?.propertyid !== "") {
        setPropertyValue([
          {
            label: crmPropertyDetailFromRTK?.propertyname,
            value: crmPropertyDetailFromRTK?.propertyid,
          },
        ]);
        propertyIdList.current = `${crmPropertyDetailFromRTK?.propertyid}`;
        RFPDataRef.current.propertyID = propertyIdList.current;
        setRFPData(RFPDataRef.current);
      }
    }
  };

  // User List By PropertyId
  const getAccountRuleList = async (propertyId) => {
    // if (propertyId !== 0) {
    let accountResponse = await AccountListCommon(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.UserManagement +
          API_URL.USER_ROLE_PROPERTY.GET_USER_LIST_BY_MODULE_MULTI_PROPERTY,
        body: {
          propertyid: RFPData?.propertyID,
          modulename: "crm",
        },
      },
      false
    );

    if (accountResponse?.isValidate) {
      setAccountList(accountResponse?.data);
      let userDropList = [],
        userIds = [];
      accountResponse?.data?.map((item) => {
        userDropList = [
          ...userDropList,
          {
            label: item?.displayname,
            value: item?.userid,
          },
        ];
        userIds = [...userIds, item?.userid];
      });
      setModuleWisePropertyDropDown(userDropList);
      setSelectedModuleWiseProperty(userDropList);
      userIdList.current = userIds?.join(",");
      RFPDataRef.current.userId = userIdList.current;
      setRFPData(RFPDataRef.current);
    }
    // }
  };

  //Opportunity Status
  const getTermListByMulCategory = async () => {
    let termListByMulCategoryResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.Configuration +
          API_URL.PROJECT_TERM.GET_LIST_BY_MULTIPLE_CATEGORY,
        body: {
          categorynamebycomma: "RFP status opportunity",
        },
      },
      false
    );

    let response = apiResponse(false, termListByMulCategoryResponse);

    if (response?.isValidate) {
      // setTermList(response?.data?.data);
      let userDropList = [],
        termIdList = [];
      response?.data?.data.map((item) => {
        userDropList = [
          ...userDropList,
          {
            label: item?.term,
            value: item?.term,
          },
        ];
        termIdList = [...termIdList, item?.term];
      });
      setTermList(userDropList);
      setStatusTerm(userDropList);
      statusList.current = termIdList?.join(",");
      RFPDataRef.current.statuses = statusList.current;
      setRFPData(RFPDataRef.current);
    }
  };

  //property select dropdown
  const handlePropertySelection = (e) => {
    if (e?.length <= 0) {
      setPropertyValue([]);
      setSelectedModuleWiseProperty([]);
      RFPDataRef.current.userId = "";
      RFPDataRef.current.propertyID = "";
      setRFPData(RFPDataRef.current);
      return;
    }
    setPropertyValue(e);
    let propertyList = [];
    e?.map((item) => {
      propertyList = [...propertyList, item?.value?.toString()];
    });
    propertyIdList.current = propertyList?.join(",");
    RFPDataRef.current.propertyID = propertyIdList.current;
    setRFPData({
      ...RFPData,
      propertyID: propertyIdList.current,
    });
  };
  //select status drop
  const handleStatusSelection = (e) => {
    if (e?.length <= 0) {
      setStatusTerm([]);
      RFPDataRef.current.statuses = "";
      setRFPData(RFPDataRef.current);
      return;
    }
    setStatusTerm(e);
    let propertyList = [];
    e?.map((item) => {
      propertyList = [...propertyList, item?.value?.toString()];
    });
    statusList.current = propertyList?.join(",");
    RFPDataRef.current.statuses = statusList.current;
    setRFPData({
      ...RFPData,
      statuses: statusList.current,
    });
  };

  // user select drop
  const handleUserSelectionFc = (e) => {
    if (e?.length <= 0) {
      setSelectedModuleWiseProperty([]);
      RFPDataRef.current.userId = "";
      setRFPData(RFPDataRef.current);
      return;
    }
    setSelectedModuleWiseProperty(e);
    let propertyList = [];
    e?.map((item) => {
      propertyList = [...propertyList, item?.value?.toString()];
    });
    userIdList.current = propertyList?.join(",");
    RFPDataRef.current.userId = userIdList.current;
    setRFPData({
      ...RFPData,
      userId: userIdList.current,
    });
  };

  const iframeloader = () => {
    setLoading(false);
  };
  const GenerateReportbtn = async () => {
    setShowPdf(false);
    setLoading(true);
    let validation = checkValidation(RFPData);

    if (!validation.isValidate) {
      RFPDataRef.current = validation;
      setRFPData(validation);
      setLoading(false);
      return;
    }

    let ActivitiesReport = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.CRM + API_URL.CRM_REPORT.RFP_GRID_REPORT,
        body: {
          propertyID: RFPData.propertyID,
          userId: RFPData.userId.toString(),
          statuses: RFPData.statuses,
          startDate: commonService.getDateInDBFormat(RFPData.startDate),
          endDate: commonService.getDateInDBFormat(RFPData.endDate),
        },
      },
      false
    );
    let response = apiResponse(false, ActivitiesReport);

    if (response?.isValidate) {
      isDefaultApiCalledRef.current = true;
      // setLoading(false);
      setshowAllReport(false);
      setErrorMessage(false);
      // successToastMessage(response?.message);
      setPdfRef.current =
        process.env.REACT_APP_APIBASEPATH_CRM_REPORT_PDF + response.data.data;
      setShowPdf(true);
    }

    if (!response?.isValidate) {
      isDefaultApiCalledRef.current = true;
      setshowAllReport(true);
      setLoading(false);
      setErrorMessage(true);
    }
  };

  useEffect(() => {
    if (RFPData.propertyID !== "") {
      if (
        !isDefaultApiCalledRef.current &&
        RFPData.userId !== "" &&
        RFPData.statuses !== ""
      ) {
        GenerateReportbtn();
      }
    }
  }, [RFPData.propertyID, RFPData.userId, RFPData.statuses]);

  useEffect(() => {
    if (crmPropertyDetailFromRTK?.propertyid === "") {
      isDefaultApiCalledRef.current = true;
      setshowAllReport(true);
    }
    getTermListByMulCategory();
    getHotelList();
  }, []);

  useEffect(() => {
    if (RFPData.propertyID !== "") {
      getAccountRuleList();
    }
  }, [RFPData.propertyID]);

  return (
    <div className="all-reports-main ToolsDisplacementCalcMain">
      <Container fluid>
        <Row>
          <Col xl={12}>
            <div className="ProspectDashboardTitleWraper  d-flex justify-content-between align-items-center marginBottom20">
              <h2 className="d-flex align-items-center gap-1">
                <Link id={commonService.generateGlobalClickTrackerID("RFPGridReport", "dashboard", "")} to="/crm/dashboard">Dashboard - </Link>{" "}
                <span className="tab-title-main">{title}</span>
              </h2>
              <div className="heading-menu-btns">
                <img id={commonService.generateGlobalClickTrackerID("RFPGridReport", "filter-report", "")}
                  src={filterIcon}
                  alt="filterIcon"
                  title="Filter Report"
                  className="cursorPointer report-filter"
                  onClick={handleshowAllReport}
                />
              </div>
            </div>
          </Col>
        </Row>

        {showAllReport && (
          <div className="displacementCalcWrapper width400">
            <div className="from-groups no-border-break mb-2 small-height-select">
              <Form.Label>Select Property</Form.Label>
              <Select id={commonService.generateGlobalClickTrackerID("RFPGridReport", "select-property", "")}
                isMulti
                value={propertyValue}
                options={selectProperty}
                onChange={(e) => {
                  handlePropertySelection(e);
                }}
              />
              {RFPData?.errorObj?.propertyID && RFPData?.propertyID === "" && (
                <small className="text-danger">
                  {RFPData?.errorObj?.propertyID}
                </small>
              )}
            </div>
            <div className="from-groups no-border-break mb-2 small-height-select">
              <Form.Label>Select User</Form.Label>

              <Select id={commonService.generateGlobalClickTrackerID("RFPGridReport", "select-user", "")}
                isMulti
                value={selectedModuleWiseProperty}
                options={moduleWisePropertyDropDown}
                onChange={(e) => {
                  handleUserSelectionFc(e);
                }}
              />
              {RFPData?.errorObj?.userId && RFPData?.userId === "" && (
                <small className="text-danger">
                  {RFPData?.errorObj?.userId}
                </small>
              )}
            </div>
            <div className="from-groups no-border-break mb-2 small-height-select">
              <Form.Label>Select Opportunity Status</Form.Label>
              <Select id={commonService.generateGlobalClickTrackerID("RFPGridReport", "select-opportunity-status", "")}
                isMulti
                value={selectStatusTerm}
                options={termList}
                onChange={(e) => {
                  handleStatusSelection(e);
                }}
              />
              {RFPData?.errorObj?.statuses && RFPData?.statuses === "" && (
                <small className="text-danger">
                  {RFPData?.errorObj?.statuses}
                </small>
              )}
            </div>
            <div className="startFrom from-groups no-border-break mb-4 meghaDatePicker">
              <Form.Label htmlFor="startDate">Date Range</Form.Label>

                          <DatePicker id={commonService.generateGlobalClickTrackerID("RFPGridReport", "date-range", "")}
                              portalId="datepicker-root"
                onChange={handleDateChange}
                startDate={RFPData.startDate}
                endDate={RFPData.endDate}
                selectsRange
                monthsShown={2}
              />
            </div>
            <div className="d-flex gap-3 align-items-center justify-content-end ">
              {loading ? (
                <button
                  className="default-btn primary-btn d-flex gap-1 align-items-center"
                  type="button"
                  disabled
                >
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Loading...
                </button>
              ) : (
                <button id={commonService.generateGlobalClickTrackerID("RFPGridReport", "generate-report", "")}
                  className="default-btn primary-btn d-flex gap-1 align-items-center"
                  onClick={() => {
                    GenerateReportbtn();
                  }}
                >
                  <span className="revpak-icon">
                    <img src={pdfIcon} alt="" />
                  </span>
                  <span>Generate Report</span>
                </button>
              )}
            </div>
          </div>
        )}
        <p className="text-center">{errorMessage && " No Record Found"}</p>
        {loading && <Loader />}
        <div className="pdf-is-showing-here mt-3">
          {showPdf && setPdfRef.current && (
            <iframe
              onLoad={iframeloader}
              title="Report Doc"
              src={setPdfRef.current}
              width="100%"
              height="800px"
            />
          )}
        </div>
        {/* {loading ? (
          <Loader />
        ) : (
          <div className="pdf-is-showing-here mt-3">
            {showPdf && setPdfRef.current && (
              <iframe
                title="Report Doc"
                src={setPdfRef.current}
                width="100%"
                height="800px"
              />
            )}
          </div>
        )} */}
      </Container>
    </div>
  );
};

export default RFPGridReport;
